import React from "react";
import Form from "../../components/Form/Form";

const Contact = () => (
  <div>
    <div
      className="section has-text-light"
      style={{ background: "rgb(54,54,54)" }}
    >
      <div className="container">
        <div className="columns">
          <div className="column is-5-desktop is-12-touch">
            <h1 className="title is-3 has-text-light">Contact Us</h1>
          </div>
        </div>
      </div>
    </div>
    <div className="section has-text-centered">
      <h2 className="subtitle is-5">
        Please leave us a brief message and we'll respond to your inquiry as
        soon as possible.
      </h2>
    </div>
    <div className="section container">
      <div className="columns is-centered">
        <div className="column is-7">
          <Form />
        </div>
      </div>
    </div>
  </div>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/Contact/Contact.js